@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.uploadInputWrapper {
  margin: variables.$std-margin-md 0;

  .inputElement {
    display: none;
  }
}
